
/**
 * Pour vérifier la règle CSS qui détermine si on est en résolution mobile ou desktop/tablette
 * selon la résolution on lance la fonction appropriée
 */
function AjustSize() {

    if ($("#checkSize").css("float") == "none") {
        FormatMobile();
    } else {
        FormatDesktop();
    }

    //Les version avec le nouveau thème on besoin d'ajuster les différents panneaux selon la résolution
    if (designVer == '1.1') {
        RightPanelPos();
        RDVPanelPos();
        FilterPanelPos();
        LeftMenuHeight();
        SizePageRDV();
        AjustAppPosCookieConsent();

        //EvalSlide = $('#Evalslider-container').width();
        $('#Evalslider-container').scrollLeft(0);

    }

}
window.AjustSize = AjustSize;

/**
 * Ajuste la hauteur de la section de la barre de gauche
 */
function LeftButtonsHeight() {

    $('.leftBtnContainer').css('height', '100%');

}
window.LeftButtonsHeight = LeftButtonsHeight;

/**
 * Vérifie encore la règle et retourne le mode d'affichage
 */
function CheckSize() {
    if ($("#checkSize").css("float") == "none") {
        return 'mobile';
    } else {
        return 'desktop';
    }
}
window.CheckSize = CheckSize;

/**
 * Fonction pour formatter en mode mobile
 */
function FormatMobile() {


    $('.mode-desktop').hide();
    $('#mySidenav').css('width', LeftNavCloseMobile);
    $('#mySidenav').css('display', 'none');
    $('#mySidenav [data-toggle="tooltip"]').tooltip('disable');
    $('#topMenu').hide();
}
window.FormatMobile = FormatMobile;

/**
 * Fonction pour formatter en mode desktop
 */
function FormatDesktop() {

    $('.mode-desktop').show();
    $('#mySidenav').css('width', LeftNavCloseDesktop);
    $('#mySidenav').css('display', 'block');
    $('#mySidenav [data-toggle="tooltip"]').tooltip('enable');
    $('#topMenu').show();

}
window.FormatDesktop = FormatDesktop;



/**
 * Positionne le panneau latéral droit selon la résolution
 */
function RightPanelPos() {

    //Pour le  calcul de la hauteur
    var totalHeight = parseInt($(window).height(), 10);

    //En desktop le panneau latéral de droite s'ouvre à partir de la fin du max de l'affichage desktop (1280px)
    //on calcule la position selon le coté droit du contenant de l,application
    //le masque de fond occupe la fin du panneau jusqu'a la limite de l'écran de droite
    if ($(window).width() > parseInt(GlobalNav.DesktopBreakpoint, 10)) {

        //hauteur du panneau = hauteur total de la fenetre - (hauteur de l'entete - hauteur des boutons du bas)
        var detailHeight = totalHeight - 105;

        if (NoRDVBtn) {

            $('.rightPanelContainer').css('padding-bottom', '90px');
        } else {
            $('.rightPanelContainer').css('padding-bottom', '0px');
        }

        //applique la hauteur au panneau
        $('.rightPanelContainer').height(detailHeight + 'px');

        //largeur total du contenant de l'application - largeur du panneau latéral = marge de gauche pour positionner le panneau
        var leftBorder = $('.AppMainContainer').outerWidth() - parseInt(GlobalNav.DesktopSideMenuOpen, 10) + 18;

        //calcul pour positionner le masque de droite, il sera afficher par dessus le restant de l'espace entre le contenant de l'application et la fin de l'écran
        var maskPos = parseInt($('.AppMainContainer').outerWidth(), 10) + 18;
        $('.rightPanelMask').css('left', maskPos);
        $('.rightPanel').css('left', leftBorder);
        $('.rightPanelMask').width('100%');

        //En mobile, le panneau occupe tout l'écran et on remonte les boutons au dessus du menu du bas
    } else {

        //hauteur du panneau = hauteur total de la fenetre - (hauteur de l'entete - hauteur des boutons du bas)
        var detailHeight = totalHeight - 155;

        if (NoRDVBtn) {

            $('.rightPanelContainer').css('padding-bottom', '90px');
        } else {
            $('.rightPanelContainer').css('padding-bottom', '0px');
        }

        //applique la hauteur au panneau
        $('.rightPanelContainer').height(detailHeight + 'px');

        $('.rightPanel').css('left', 'unset');
        $('.rightPanel').css('right', '0');
        $('.rightPanelMask').css('right', '0');
        $('.rightPanelMask').hide();

    }

}
window.RightPanelPos = RightPanelPos;

/**
 * Ajustement de la position et de la hauteur du panneau des rdv
 * @param {boolean} hourrange   Utilisé avec l'affichage des heures
 */
function RDVPanelPos(hourrange) {

    //Pour le calcul de la hauteur
    var totalHeight = parseInt($(window).height(), 10); //hauteur totale de l'écran
    var headerHeight = parseInt($('.rdvPanelDetailHeader').height(), 10); //hauteur de l'entête
    var rdvBtnHeight = 80; //hauteur du div contenant les bouton dans le bas du panneau

    //En desktop le panneau latéral de droite s'ouvre à partir de la fin du max de l'affichage desktop (1280px)
    //on calcule la position selon le coté droit du contenant de l,application
    //le masque de fond occupe la fin du panneau jusqu'a la limite de l'écran de droite
    if ($(window).width() > parseInt(GlobalNav.DesktopBreakpoint, 10)) {

        if (bottomControlOpen) {
            rdvBtnHeight = 0;

        } else {
            rdvBtnHeight = 65;
        }

        var detailHeight = (totalHeight - 108) + rdvBtnHeight;

        $('.rdvPanelContainer').height(detailHeight + 'px');

        //largeur total du contenant de l'application - largeur du panneau latéral = marge de gauche pour positionner le panneau
        var leftBorder = $('.AppMainContainer').outerWidth() - parseInt(GlobalNav.DesktopSideMenuOpen, 10) + 18;

        //calcul pour positionner le masque de droite, il sera afficher par dessus le restant de l'espace entre le contenant de l'application et la fin de l'écran
        var maskPos = $('.AppMainContainer').outerWidth() + 18;

        //Ajuste les marges selon les calculs
        $('.rdvPanelMask').css('left', maskPos);
        $('.rdvPanel').css('left', leftBorder);
        $('.rdvPanelMask').width('100%');

        if ($('#rdvCalendar > * .fc-unselectable').length > 0) {
            var wt = $('#rdvCalendar > * .fc-unselectable').position().top;
            var wh = $('#rdvCalendar > * .fc-unselectable').height();

        }

        if (NoRDVBtn) {
            $('.rightPanelRDVBtn').hide();

        }

        //En mobile, le panneau occupe tout l'écran, mais il faut réduire la hauteur du au menu du bas
    } else {

        //    $('.calLegend').css('left', '0');
        if ($('#rdvCalendar > * .fc-unselectable').length > 0) {
            var Pos = $('#rdvCalendar')[0].offsetLeft;
            var wt = $('#rdvCalendar > * .fc-unselectable').position().top;
            var wh = $('#rdvCalendar > * .fc-unselectable').height();

        }

        var bottomMenuH = $('.bottomBtnContainer').height();

        if (bottomControlOpen) {
            // $('.rdvPanelRDVBtn').css('bottom', bottomMenuH + 'px');
        } else {
            rdvBtnHeight = rdvBtnHeight - 34;
        }

        var detailHeight = totalHeight - 158;

        if (hourrange) {
            detailHeight = detailHeight + 69;
        }

        $('.rdvPanelContainer').height(detailHeight + 'px');


        $('.rdvPanel').css('left', 'unset');
        $('.rdvPanel').css('right', '0');
        $('.rdvPanelMask').css('right', '0');

        //Le masque n'est pas nécessaire en mobile puisque tout l'espace est occupé par l'app
        $('.rdvPanelMask').hide();

        if (NoRDVBtn) {
            $('.rightPanelRDVBtn').hide();
        }

    }

}
window.RDVPanelPos = RDVPanelPos;

/**
 * Ajustement de la position et de la hauteur du panneau des filtres
 */
function FilterPanelPos() {

    //Pour le calcul de la hauteur
    var totalHeight = parseInt($(window).height(), 10); //hauteur totale de l'écran
    var rdvBtnHeight = 80; //hauteur du div contenant les bouton dans le bas du panneau

    //En desktop le panneau latéral de droite s'ouvre à partir de la fin du max de l'affichage desktop (1280px)
    //on calcule la position selon le coté droit du contenant de l,application
    //le masque de fond occupe la fin du panneau jusqu'a la limite de l'écran de droite
    if ($(window).width() > parseInt(GlobalNav.DesktopBreakpoint, 10)) {

        //largeur total du contenant de l'application - largeur du panneau latéral = marge de gauche pour positionner le panneau
        var leftBorder = $('.AppMainContainer').outerWidth() - parseInt(GlobalNav.DesktopSideMenuOpen, 10) + 18;

        //calcul pour positionner le masque de droite, il sera afficher par dessus le restant de l'espace entre le contenant de l'application et la fin de l'écran
        var maskPos = $('.AppMainContainer').outerWidth() + 18;

        //Ajuste les marges selon les calculs
        $('.filterPanelMask').css('left', maskPos);
        $('.filterPanel').css('left', leftBorder);
        $('.filterPanelMask').width('100%');

        //En mobile, le panneau occupe tout l'écran, mais il faut réduire la hauteur du au menu du bas
    } else {

        $('.filterPanel').css('left', 'unset');
        $('.filterPanel').css('right', '0');
        $('.filterPanelMask').css('right', '0');
        $('.filterPanelMask').hide();

    }

}
window.FilterPanelPos = FilterPanelPos;

/**
 * Ajustement de la hauteur du menu de gauche
 */
function LeftMenuHeight() {

    //Matrice qui va contenir toutes les possibilités de hauteur
    var screenHeight = new Array();

    //Ajustement seulement en mode desktop
    if ($(window).width() > parseInt(GlobalNav.TabletBreakpoint, 10)) {

        screenHeight.push(parseInt($(window).height(), 10)); //hauteur de la fenêtre du browser
        screenHeight.push(parseInt($('.AppMainContainer').height(), 10)); //hauteur du div de l'application

        if ($('.lastCard').length) {
            screenHeight.push($('.lastCard').position().top + 444); //si on est dans la page  ou donner, la hauteur calculé selon la position de la dernière carte
        }

        if ($('.RDVLastCard').length) {
            screenHeight.push($('.RDVLastCard').position().top + 444); //si on est dans la page mes dons, la hauteur calculé selon la position de la dernière carte
        }

    }

    if ($('.DONSLastCard').length) {
        screenHeight.push($('.DONSLastCard').position().top + 244); //si on est dans la page mes dons, la hauteur calculé selon la position de la dernière carte
        screenHeight.push($('#mesDonFooter').position().top + 244);
    }

    //On prend la hauteur maximale dans la matrice pour fixer la hauteur de la bande bleu de gauche
    var totalHeight = Math.max(...screenHeight);

    $('.leftBtnContainer').outerHeight(totalHeight + 'px');
    if ($('.DONSLastCard').length) {
        totalHeight = totalHeight - 135;
    }
    $('.mesDONSContainer').outerHeight(totalHeight + 'px');

}
window.LeftMenuHeight = LeftMenuHeight;


/**
 * ajuste la hauteur de la page des RDV
 */
function SizePageRDV() {

    //Ajustement seulement en mode desktop
    if ($(window).width() > parseInt(GlobalNav.TabletBreakpoint, 10)) {

        if ($('.RDVLastCard').length) {
            var h = $('.RDVLastCard').position().top + $('.RDVLastCard').height();

            $('.mesRDVContainer').height(h + 'px');
        }

    }

}
window.SizePageRDV = SizePageRDV;